/**
 * polyfill ie object-fit for video tags
 */
export function polyfillObjectFitVideo (video) {
    if (!('objectFit' in document.documentElement.style)) {
        const videoElement = $(video)
        const containerElement = videoElement.parent()

        containerElement.css({ position: 'relative' })
        videoElement.css({
            width: '100%',
            height: 'auto',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        })

        const videoAspectRatio = videoElement.width() / videoElement.height()

        const resize = function() {
            const containerAspectRatio = containerElement.width() / containerElement.height()

            if (containerAspectRatio < videoAspectRatio) {
                const scale = containerElement.height() / (containerElement.width() / videoAspectRatio)
                videoElement.css('width', `${100 * scale}%`)
            }
        }

        resize()
        $(window).on('resize', resize)
    }
}

/**
 * method for Google Analytics and Yandex Metrika
 */
export function targetAnalytics (event) {
    yaCounter12917275.reachGoal(event.target.dataset.target)
    ga('send', 'event', event.target.dataset.category, 'click', event.target.dataset.label)
}



// WEBPACK FOOTER //
// ./frontend/utils/util.js